import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBookActions, useUiState } from './store/BookStoreProvider';

// Messages flottants, en BAS de l'ecran, par-dessus le contenu : ils ne
// poussent jamais la mise en page. Remplacent le bandeau ambre
// "Annuler — revenir a ..." (qui deplacait le livre), le bandeau de retour au
// livre d'avant la composition automatique et le bloc d'erreur rouge du panneau.
//
// Un message avec action ("Annuler") reste plus longtemps ; un message
// `persistent` (ex. "Vous testez la version automatique") reste jusqu'a ce
// qu'on le ferme ou qu'on agisse.
const DURATION_MS = 5000;
const DURATION_WITH_ACTION_MS = 9000;

function Toast({ toast, onAction, onDismiss, dismissLabel }) {
  useEffect(() => {
    if (toast.persistent) return undefined;
    const timer = setTimeout(onDismiss, toast.actionLabel ? DURATION_WITH_ACTION_MS : DURATION_MS);
    return () => clearTimeout(timer);
    // Un message de meme id qui revient (nouveau geste) repart pour un tour.
  }, [toast, onDismiss]);

  return (
    <div className="atelier-toast" role="status">
      <span className="atelier-toast-message">{toast.message}</span>
      {toast.actionLabel && (
        <button type="button" className="atelier-toast-action" onClick={onAction}>
          {toast.actionLabel}
        </button>
      )}
      {toast.extraActions && toast.extraActions.map((extra) => (
        <button key={extra.label} type="button" className="atelier-toast-action" onClick={extra.onClick}>
          {extra.label}
        </button>
      ))}
      <button type="button" className="atelier-toast-close" onClick={onDismiss} aria-label={dismissLabel}>×</button>
    </div>
  );
}

export default function AtelierToasts() {
  const { t } = useTranslation('atelier');
  const { toasts } = useUiState();
  const { runToastAction, dismissToast } = useBookActions();

  if (toasts.length === 0) return null;
  return (
    <div className="atelier-toasts" aria-live="polite">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onAction={() => runToastAction(toast.id)}
          onDismiss={() => dismissToast(toast.id)}
          dismissLabel={t('store.toasts.dismiss')}
        />
      ))}
    </div>
  );
}
